export const files = [
  { label: "PDF", value: "pdf", mimeType: "application/pdf" },
  {
    label: "DOCX",
    value: "docx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  { label: "TXT", value: "txt", mimeType: "text/plain" },
  { label: "XLSX", value: "xlsx", mimeType: "",disabled: true },
  { label: "CSV", value: "csv", mimeType: "",disabled: true },
  { label: "TSV", value: "tsv", mimeType: "",disabled: true },
  {
    label: "PPTX",
    value: "pptx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    disabled: true
  },
  { label: "JPG", value: "jpg", mimeType: "image/jpg",disabled: true},
  { label: "PNG", value: "png", mimeType: "image/png" },
];
